import { createContext } from "react";
import { ChatContextProps } from "../../interfaces/chat";

const ChatContext = createContext<ChatContextProps>({} as ChatContextProps);

export default ChatContext;
